import { enableProdMode, importProvidersFrom } from '@angular/core';
import { provideOpenFirebase } from '@open/ngx-firebase/app';
import { EMULATION_MODE } from '@assets/api-mapping';
import { Environment, firebaseConfig } from '@assets/firebase.config';

import { environment } from './environments/environment';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { DeviceConfigService } from './app/services/device-config.service';
import { registerLocaleData } from '@angular/common';
import fr from '@angular/common/locales/fr';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { APP_ROUTES } from './app/app.routes';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app/app.component';

CapacitorUpdater.notifyAppReady();
registerLocaleData(fr);

if (environment.envName === 'PROD') {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideOpenFirebase({
      options: firebaseConfig[environment.envName as Environment],
      emulationMode: EMULATION_MODE,
      persistence: 'indexed-db',
    }),
    importProvidersFrom(
      BrowserModule,
      IonicModule.forRoot(),
      FormsModule,
      HttpClientModule
    ),
    provideRouter(APP_ROUTES, withPreloading(PreloadAllModules)),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    DeviceConfigService,
  ],
}).catch((err) => console.log(err));
